module.exports = __webpack_public_path__ + "img/construction_boby.72737b10.png";